import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { MarkdownModule } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';

import { cn } from '@valk-nx/core/lib/core';

import { AlertType } from './contracts/alert.types';

@Component({
	selector: 'vp-alert',
	imports: [AngularSvgIconModule, CommonModule, MarkdownModule, ToastrModule],
	templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit {
	title = input('');
	content = input('');
	subContent = input('');
	closeable = input(false);
	emphasized = input(false);
	isToastr = input(false);
	hasElevation = input(false);
	type = input<AlertType>('dialog--info');
	size = input<'base' | 'small'>('base');
	className = input('');

	closeEmitter = output<void>();

	animationState = 'visible';
	hidden = false;

	cn = cn;

	ngOnInit(): void {
		if (this.isToastr()) {
			this.animationState = 'visible';
		}
	}

	remove() {
		if (this.isToastr()) {
			this.closeEmitter.emit();
		} else {
			this.animationState = 'hidden';
		}
	}

	onAlertVisibilityChange() {
		if (this.animationState === 'hidden' && !this.isToastr()) {
			this.hidden = true;
		}
	}
}
